// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import styles from './styles.scss';

import { preloader } from '../../utils/animation';
import { getCategory, getAttributes } from '../../utils/methods.js';
import ContactButton from '../../components/Contact/Button';

import type { CategoryType } from '../../api/types';
import type { DefaultStateType } from '../../redux/reducers';

type Props = {
  categories: Array<CategoryType>,
};

type State = {
  index: number,
};

class Technicians extends React.Component<Props, State> {
  state = {
    index: 0,
  };

  componentDidMount() {
    preloader().play();
    if (document && document.body) {
      document.body.classList.add('technicians');
    }
  }

  componentWillUnmount() {
    if (document && document.body) {
      document.body.classList.remove('technicians');
    }
  }

  render() {
    const { categories } = this.props;

    if (!categories) {
      return <div>loading...</div>;
    }

    const category = getCategory(categories, 'technicians');
    const attributes = getAttributes(category);

    const bgImage = attributes.find(attr => attr.name.toLocaleLowerCase() === 'technicians background');
    const title = attributes.find(attr => attr.name.toLocaleLowerCase() === 'title');
    const description = attributes.find(attr => attr.name.toLocaleLowerCase() === 'description');
    const images = attributes
      .filter(attr => attr.name.toLocaleLowerCase().includes('technicians image'))
      .map(attr => attr.value);

    return attributes.length ? (
      <React.Fragment>
        <div className={styles.hero} style={{ backgroundImage: `url(${bgImage ? bgImage.value : ''})` }}>
          <div className={styles.title}>
            <h1>Technicians</h1>
          </div>
        </div>

        <div className={styles.content}>
          {/*{images.length > 0 && images.map(img => <img src={img} key={img} alt="technicians" />)}*/}
          <div className={styles.left}>
            <div className={styles.item}>
              <div className="img-cover">
                <img src={images[0]} alt="technicians-1" />
                <div className="sail" />
              </div>
            </div>
            <div className={classnames(styles.description, styles.item)}>
              {/* $FlowFixMe */}
              <h3 className={styles['desc-title']}>{title ? title.value : ''}</h3>
              <p>{description ? description.value : ''}</p>
            </div>
            <div className={styles.item}>
              <div className="img-cover">
                <img src={images[3]} alt="technicians-2" />
                <div className="sail" />
              </div>
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.item}>
              <div className="img-cover">
                <img src={images[1]} alt="technicians-3" />
                <div className="sail" />
              </div>
            </div>
            <div className={styles.item}>
              <div className="img-cover">
                <img src={images[2]} alt="technicians-4" />
                <div className="sail" />
              </div>
            </div>
            <div className={classnames(styles.item, styles.consultation)}>
              <h4>Have a question?</h4>
              <ContactButton />
            </div>
          </div>
        </div>
      </React.Fragment>
    ) : (
      <div>loading...</div>
    );
  }
}

const mapStateToProps = (state: DefaultStateType) => ({ categories: state.categories });

export default connect(mapStateToProps)(Technicians);



// WEBPACK FOOTER //
// ./src/pages/Technicians/index.js